/*=========================================================================================
  File Name: moduleMailSendResumeActions.js
  Description: MailSendResume Module Actions
  ----------------------------------------------------------------------------------------
==============================*/
import mailSendResumeService from "../../../services/mailSendResume.service"

export default {
  fetchMailSendResume ({ commit, dispatch }, payload) {
    return mailSendResumeService.getMailSendResume(payload)
      .then(response => {
        commit('SET_MAIL_SEND_RESUMES', response.data.data)
        commit('SET_INFO_DB', {totalPage: response.data.last_page, totalRow: response.data.total})
        return Promise.resolve(response.data.data)
      })
      .catch(error =>{
        if(Object.values(error.errors).length > 0){
          dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
        }
        else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
      })
  },
  showMailSendResume ({dispatch}, id) {
    return mailSendResumeService.showMailSendResume(id)
      .then(response => {
        return Promise.resolve(response.data)
      })
      .catch(error =>{
        if(typeof error.errors == 'object'){
          if(Object.values(error.errors).length > 0){
            dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
          }
        }
        else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
      })
  },
  fetchMailTemplate ({ commit, dispatch }, payload) {
    return mailSendResumeService.getMailTemplate(payload)
        .then(response => {
          return Promise.resolve(response.data)
        })
        .catch(error =>{
          if(Object.values(error.errors).length > 0){
            dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
          }
          else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
        })
  },
}